import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { isUnitSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';


const mapFilterData = (data: IUnitSearchForm): IEstablishmentSearchPost | {} => {
  if (isUnitSearchFormEmpty(data) || data == undefined) { return {} }
  const removedUnusedFilters = filterNonEmptyValues(data);
  return removedUnusedFilters;
}

const getAllUnits = async ( {data} : {data: IUnitSearchForm}): Promise<IGetUnit> => {
  const requestData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;
  const response =  await axiosDefaultApi.post(`api/Search/Search/Units?pageNumber=1&pageSize=5000&deleted=${deleted}`, requestData);
  return response as unknown as IGetUnit;
};

type QueryFnType = typeof getAllUnits;

type UseGetAllUnitsOptions = {
  data: IUnitSearchForm;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllUnits = ({ data, config }: UseGetAllUnitsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllUnits'],
    queryFn: () => getAllUnits({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};